if (!customElements.get('count-up')) {
  class CountUp extends HTMLElement {
    constructor() {
      super();
      this.counter = this.querySelector('.value');
      this.speed = 500;
      this._hasAnimated = false;
      this._observer = new IntersectionObserver(this._handleIntersect.bind(this), {
        threshold: 0.6,
      });
    }

    connectedCallback() {
      if (this.counter) {
        this._observer.observe(this);
      }
    }

    disconnectedCallback() {
      this._observer.disconnect();
    }

    _handleIntersect(entries) {
      const [entry] = entries;
      if (entry.isIntersecting && !this._hasAnimated) {
        this._hasAnimated = true;
        this._observer.disconnect();
        this._animate();
      }
    }

    _animate() {
      const value = +this.counter.getAttribute('value');
      const update = () => {
        const current = +this.counter.innerText;
        const increment = value / this.speed;

        if (current < value) {
          this.counter.innerText = Math.ceil(current + increment);
          setTimeout(update, 1);
        } else {
          this.counter.innerText = value;
        }
      };
      update();
    }
  }

  customElements.define('count-up', CountUp);
}
